export default __webpack_public_path__ + "static/media/img2.aa05a8e1.jpg";